import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="performances--performance-field"

export default class extends Controller {
  static targets = [
    "timeSliceSelect",
    "sliceStart",
    "sliceEnd",
    "workManDays",
    "workTimeSpan",
    "tool",
    "toolManDays",
    "toolTimeSpan"
  ]


  add() {
    const container = this.element.parentElement

    const template = container.querySelector('template')
    if (!template) {
      console.error('Template not found')
      return
    }

    const currentIndices = Array.from(container.querySelectorAll('.performances-field'))
      .map(field => parseInt(field.dataset.index || '-1', 10))
      .filter(index => !Number.isNaN(index))

    const lastIndex = currentIndices.length > 0 ? Math.max(...currentIndices) : -1
    const newIndex = lastIndex + 1

    const clone = template.content.cloneNode(true)

    const wrapper = clone.querySelector('.performances-field')
    if (wrapper) {
      wrapper.dataset.index = newIndex.toString()
      wrapper.querySelectorAll('[name], [id]').forEach(field => {
        if (field.name) {
          field.name = field.name.replace(/performances_attributes\]\[\d+\]/, `performances_attributes][${newIndex}]`)
        }
        if (field.id) {
          field.id = field.id.replace(/performances_attributes_\d+_/, `performances_attributes_${newIndex}_`)
        }
      })
    }

    template.parentNode.insertBefore(clone, template)
  }

  remove(event) {
    const wrapper = event.target.closest('.performances-field')
    if (!wrapper) return

    const parent = wrapper.parentElement
    const destroyInput = wrapper.querySelector('input[name*="_destroy"]')

    const visibleRows = Array.from(parent.querySelectorAll('.performances-field'))
      .filter(row => row.style.display !== 'none')

    const isLastVisibleRow = visibleRows.length === 1

    if (destroyInput) {
      destroyInput.value = true
      wrapper.style.display = 'none'

      if (isLastVisibleRow) {
        this.add()
      }

      return
    }

    if (!isLastVisibleRow) {
      wrapper.remove()
    }
  }

  handleTimeSliceChange(event) {
    if (!event.target.options[event.target.selectedIndex].dataset.timeSlice) return;
    this.timeSliceData = JSON.parse(event.target.options[event.target.selectedIndex].dataset.timeSlice)

    // UPDATE 開始 & 終了
    const startTime = this.timeSliceData.start_time
    const endTime = this.timeSliceData.end_time
    if (this.sliceStartTarget && this.sliceEndTarget) {
      this.sliceStartTarget.value = startTime || ""
      this.sliceEndTarget.value = endTime || ""
    }

    // UPDATE 時間(h) & 人工
    const man_days = this.timeSliceData.man_days;
    const duration = this.timeSliceData.duration || "0";
    const hours = Math.floor(duration / 60);
    const minutes = Math.round((duration / 60 - hours) * 60);
    this.workTimeSpanTarget.value = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`; //時間(h)
    this.workManDaysTarget.value = man_days //人工

    this.handleToolChange();
  }

  // UPDATE 機械時間 & 機械工数
  handleToolChange() {
    if (!this.toolTarget.value || (!this.workManDaysTarget.value && !this.workTimeSpanTarget.value)) {
      this.toolManDaysTarget.value = null;
      this.toolTimeSpanTarget.value = null;
      return;
    };
    this.toolManDaysTarget.value = this.workManDaysTarget.value;
    this.toolTimeSpanTarget.value = this.workTimeSpanTarget.value;
  }
}
